import { useEffect } from 'react'

/**
 * @description useOnPageChange - run a function when the page changes
 * @param {object} history - react-router-dom history object
 * @param {function} fn - function to run on page change
 * @returns {void}
 * @example
 * useOnPageChange(history, (location, action) => {
 *  console.log('The current URL is', location.pathname)
 *  console.log('The last navigation action was', action)
 * })
 * @see https://reactrouter.com/web/api/history
 **/
export const useOnPageChange = (history: any, fn: (location: object, action: any) => void) => {
  useEffect(() => {
    let unlisten: undefined | (() => void)

    if (!unlisten) {
      unlisten = history.listen(fn)
      fn(history.location, 'initial')
    }

    return () => {
      if (unlisten) unlisten()
    }
  }, [history, fn])
}
